/**
 * Analytics Event Value Object
 * Represents a trackable event in the application
 */
export class AnalyticsEvent {
    private constructor(
        public readonly category: string,
        public readonly action: string,
        public readonly label?: string,
        public readonly value?: number,
        public readonly metadata?: Record<string, any>
    ) { }

    static create(params: {
        category: string;
        action: string;
        label?: string;
        value?: number;
        metadata?: Record<string, any>;
    }): AnalyticsEvent {
        if (!params.category || params.category.trim() === '') {
            throw new Error('Event category is required');
        }
        if (!params.action || params.action.trim() === '') {
            throw new Error('Event action is required');
        }

        return new AnalyticsEvent(
            params.category,
            params.action,
            params.label,
            params.value,
            params.metadata
        );
    }

    /**
     * Convert to plain object for tracking
     */
    toTrackingData(): {
        category: string;
        action: string;
        label?: string;
        value?: number;
        [key: string]: any;
    } {
        return {
            category: this.category,
            action: this.action,
            ...(this.label && { label: this.label }),
            ...(this.value !== undefined && { value: this.value }),
            ...(this.metadata && this.metadata),
        };
    }
}
